import React from "react";
import { Modal} from "antd";
import { URL_SKIM, URL_TRUCK } from "../../constants/urls";
import ErrorMessages from "../../common/ErrorMessages";
import ColorButton from "../../common/ColorButton";
import TSTable from "../../common/TSTable";
import { dateTimeToHumanString } from "../../frameworks/Util";
import _ from "lodash";

export default function SkimChemicalLogView(props) {
  const { open, onClose, target, direction } = props;
  const [ errorMessage, setErrorMessage ] = React.useState();
  const tableRef = React.useRef();
  const columns = [
    {
      title: 'วัน - เวลา',
      dataIndex: 'thicken',
      key: 'thicken',
      render : (value) => dateTimeToHumanString(value),
    },
    {
      title: 'สารเคมี',
      dataIndex: 'chemical_name',
      key: 'weight',      
    },
    {
      title: 'จำนวน',
      dataIndex: 'thickening_amount',
      key: 'thickening_amount',
      render : (value) => <center>{value}</center>
    },

  ]

  const refreshData = async() => {
    if(tableRef.current)(
      await tableRef.current.fetchWithoutResetPage()
    )
  }

  React.useState(() => {
    if(target){
      refreshData();
    }
  },[target])

  React.useEffect(() => {
    setErrorMessage(null)
  },[open])

  return(
    <Modal
      title={<center>ประวัติเติมสารเคมี</center>}
      open={open}
      onCancel={onClose}
      width={600}
      destroyOnClose
      footer={[
        <ColorButton onClick={onClose}>ปิด</ColorButton>
      ]}
    >
      <ErrorMessages message={errorMessage}/>
      <TSTable
        ref={tableRef}
        columns={columns}
        size={'small'}
        url={URL_SKIM.SKIM_INPUT_CHEMICAL_TRANSACTION}
        params={{transaction : target}}
      />
    </Modal>
  )
}